export default __webpack_public_path__ + "static/media/formIcon.ff4311be.png";